<p>
  safety-induction-setup works!
</p>
